import axios from '../axios';
import * as models from '../models';
import { Format } from '../phone';
import { GetPageRequestID } from './pagerequests';
import { UserDetails } from './users';

declare interface getUserTaxExemptionsResp {
    userTaxExemptions: models.UserTaxExemption[];
    userTaxExemptionReasons?: models.UserTaxExemptionReason[];
}

export async function GetUserTaxExemptions(params?: Record<string, string>): Promise<models.UserTaxExemption[]> {
    return axios.get<getUserTaxExemptionsResp>('/user-tax-exemptions', { params }).then(resp => resp.data.userTaxExemptions);
}

export declare interface NewUserTaxExemptionOptions {
    user: UserDetails;
    userTaxExemptReasonID: number;
    number: string;
    countryID: number;
    stateID?: number;
    uploadIDs: number[];
    label?: string;
}

export async function NewUserTaxExemption(opts: NewUserTaxExemptionOptions): Promise<models.UserTaxExemption> {
    opts.user.tz ??= Intl.DateTimeFormat().resolvedOptions().timeZone;
    opts.user.pageRequestID ??= await GetPageRequestID();
    opts.user.phone = Format(opts.user.phone);

    return axios.post<models.UserTaxExemption>('/user-tax-exemptions', opts).
        then(resp => resp.data);
}

export function DeleteUserTaxExemption(userTaxExemptionID: string) {
    return axios.delete(`/user-tax-exemptions/${userTaxExemptionID}`);
}

export function RestoreUserTaxExemption(userTaxExemptionID: string) {
    return axios.patch(`/user-tax-exemptions/${userTaxExemptionID}`, { 'active': true });
}

export function UpdateUserTaxExemptionLabel(userTaxExemptionID: string, label: string) {
    return axios.patch(`/user-tax-exemptions/${userTaxExemptionID}`, { 'label': label });
}
